export const UNIT_PREFIX = {
	PICO: {
		mappingName: 'PICO',
		prefix: 'p'
	},
	NANO: {
		mappingName: 'NANO',
		prefix: 'n'
	},
	MICRO: {
		mappingName: 'MICRO',
		prefix: 'μ'
	},
	MILI: {
		mappingName: 'MILI',
		prefix: 'm'
	},
	KILO: {
		mappingName: 'KILO',
		prefix: 'k'
	},
	MEGA: {
		mappingName: 'MEGA',
		prefix: 'M'
	},
	GIGA: {
		mappingName: 'GIGA',
		prefix: 'G'
	},
	TERA: {
		mappingName: 'TERA',
		prefix: 'T'
	}
};
